export default {
  switchTab: false,
  hasConclusionNotice: false,
  unreadMessageGroup: new Set(),
  tabUnreadMessageGroup: [],
  isStcApplication: false
}